// extracted by mini-css-extract-plugin
export default {"root":"Contact_root__VoPWH"};